
<template>
      <div class="courses" v-if="courses && courses.length">
        <div class="course" v-for="course in courses" v-bind:key="course.id" >
          <img alt="Curso imagen" src="../assets/logo_oniad_academy/ONiAd-Academy-logotipo.png">
          <div class="form-vue">
            <h1>{{course.title}}</h1>
            <p v-html="course.description"></p>
            <div class="form-group-vue flex-column" v-if="notExistsInSession">
              <float-label  :main-label="'Es necesario un email para continuar'" :main-small="'Si ya has puesto antes un email puedes volver a poner el mismo'">
                <input :placeholder="'Email'"  v-model="email" class="form-control" type="email">
              </float-label>
            </div>
            <div class="form-group-vue align-left" v-if="notExistsInSession">
              <label for="terms">
                <input type="checkbox" id="terms" v-model="termsAccept"> <small>Acepto los <a href="https://platform.oniad.com/terms" target="_blank">términos y condiciones</a></small>
              </label>
            </div>
            <div class="form-group-vue align-left" v-show="errorMail">
              <div class="error">Introduce un email válido</div>
            </div>
            <div class="form-group-vue align-left" v-show="acceptedMandatory === true">
              <div class="error">Es necesario acceptar los términos y condiciones para acceder al test</div>
            </div>
          </div>
          <div class="optionsCourse">
            <button class="btn btn-success btn-lg" @click="showTemary(course)">Ver temario</button>
          </div>
        </div>
      </div>
</template>

<script>
    /* eslint-disable */
    import {mapState}       from 'vuex'
    import Vue              from "vue";
    import { VueReCaptcha } from 'vue-recaptcha-v3'
    import FloatLabel       from "./elements/FloatLabel";
    Vue.use(VueReCaptcha, {
      // siteKey: 'VUE_APP_SITEKEY_GOOGLE=6LeCHWEUAAAAADQ7nd_fa9zFdzST_rT7I1S3TU5A',
      siteKey: '6LdwsMMUAAAAAL_WkqDxsjhwD4gKvDLARybGJthf',
      loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true
      }
    });
    const uuidv4 = require('uuid/v4');

    export default {
    name: 'home',
      components:{
        FloatLabel
      },
    computed: mapState(['courses','user']),
    data(){
      return {
        email: '',
        idUser: uuidv4(),
        loading: false,
        errorMail: false,
        acceptedMandatory: false,
        termsAccept: false,
        notExistsInSession: true
      }
    },
    mounted() {
      this.getCourses();
      let u = Vue.$sessionStorage.get('user',{});
      if (u && u.email){
        this.email = u.email;
        this.notExistsInSession = false;
      }

    },
    methods:{
      getCourses(){
        this.$store.dispatch({type:'getCourses'});
      },
      showTemary(course){
        if (!this.notExistsInSession){
          this.$router.push({name: 'temary',params:{courseSlug:course.slug}});
        }
        this.errorMail = false;
        this.acceptedMandatory = false;
        if (!this.termsAccept) {
          this.acceptedMandatory = true;
          return false;
        }
        if (!/\S+@\S+\.\S+/.test(this.email) || !this.email.length) {
          this.errorMail = true;
          return false;
        }
        this.loading = true;
        this.$recaptcha().then((token) => {
          // console.log(token) // Will print the token
          if(!token){return false;}

          this.userExists().then((data)=> {
            Vue.$sessionStorage.set('user', {email: this.email});
          })
          .then(()=>{
            this.$gtm.trackEvent({
              event: 'academy.accessUser', // Event type [default = 'interaction'] (Optional)
              category: 'academy',
              action: 'user_access',
              label: 'Acceso usuario',
              value: 0,
              // noninteraction: false // Optional
            });
          })
          .then(()=>{
            // this.emailJson = {user:data.id,test:this.courses[0].id,tag:'access_request'};
            this.goTemary(course);
            // this.$router.push({name: 'temary',params:{courseSlug:course.slug}});

            // this.sendEmail();
          })
          .catch((e)=>{
            if (e.status === 404){
              this.userCreate()
                      .then(()=>{
                        Vue.$sessionStorage.set('user',{email:this.email});
                      })
                      .then(()=>{
                        this.$gtm.trackEvent({
                          event: 'academy.accessNewUser', // Event type [default = 'interaction'] (Optional)
                          category: 'academy',
                          action: 'new_user_access',
                          label: 'Acceso nuevo usuario',
                          value: 0,
                          // noninteraction: false // Optional
                        });
                      })
                      .then(()=>{
                        this.goTemary(course);

                // this.$router.push({name: 'temary',params:{courseSlug:this.courses[0].slug}});

                // this.sendEmail();
              }).catch(console.error)
            }
          })
        }).catch(()=>{this.loading = false;});
      },
      goTemary(course){
        this.$router.push({name: 'temary',params:{courseSlug:course.slug}});
      },
      userExists(){
        return this.$store.dispatch({type:'getUserByEmail',data:{email: this.email}});
      },
      userCreate(){
        return this.$store.dispatch({type:'postUser',data:{id:this.idUser,email: this.email}})
      },
    }
  }
</script>

<style lang="scss">
  .optionsCourse{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    width: 100%;
    margin: 2em;
  }
  .courses{
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 1em;
    .course{
      display: flex;
      flex-direction: column;
      max-width: 600px;
      align-items: center;
      align-self: center;
      margin: 4em 0;
      img{
        max-width: 400px;
        margin-bottom: 2em;
      }
    }
  }
  .mainContent{
    position: relative;
  }
  .load-spinner{
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
    top: 0;
    left: 0;
    div{
      border-radius: 5px;
      background-color:rgb(54, 198, 211);
      margin: 0.25em;
    }
  }
</style>
